export default "__VITE_ASSET__faf3ed82__"